import { render, staticRenderFns } from "./PrevButton.vue?vue&type=template&id=383f41e8&scoped=true"
import script from "./PrevButton.vue?vue&type=script&lang=js"
export * from "./PrevButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383f41e8",
  null
  
)

export default component.exports